import { acceptNotification } from './features/admin/notifications/notification-service';
import { NotificationsContext } from './core/components/NotificationsContext';
import { getDescription } from './features/admin/notifications/steps/utils';
import { NotificationsModal } from '@/app/core/components/NotificationsModal';
import { useState, useContext, useEffect } from 'react';
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { AiOutlineClose, AiOutlineWarning } from 'react-icons/ai/index.js';
import { NotificationWithAcceptance } from '@ssar-app/domain';

export const NotificationHeader = () => {
  const { getNotifications, notifications } = useContext(NotificationsContext);
  const [notifs, setNotifs] = useState<NotificationWithAcceptance[]>([]);
  const [showNotifications, setShowNotifications] = useState(false);

  const handleUserAccept = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptNotification([(notifs[0] as any).id]).then(() => {
      getNotifications();
    });
  };
  useEffect(() => {
    setNotifs(() => {
      return notifications.filter((notif) => !notif.isAccepted);
    });
  }, [notifications]);

  return (
    <>
      {notifs.length > 0 && (
        <>
          <NotificationsModal
            showNotifications={showNotifications}
            setShowNotifications={setShowNotifications}
          />
          <Flex
            as='header'
            h={16}
            gap={4}
            background='raspberry.600'
            alignItems='center'
            px={2}
          >
            <Icon
              as={AiOutlineWarning}
              fontSize='4xl'
              color='orange'
              bg='white'
              p='6px'
              borderRadius='full'
            />
            <Flex
              fontSize='lg'
              color='white'
              lineHeight='24px'
              width='100%'
              overflow='hidden'
              display={'block'}
            >
              <Text
                whiteSpace='pre'
                mb={0}
                textOverflow='ellipsis'
                overflow='hidden'
                fontWeight={'bold'}
                fontSize='16px'
              >
                {notifs[0].title}
              </Text>
              <Text
                whiteSpace='pre'
                mb={0}
                textOverflow='ellipsis'
                overflow='hidden'
                fontSize='14px'
              >
                {getDescription(notifs[0])}
              </Text>
            </Flex>
            {notifs.length > 1 && (
              <Button
                ml='auto'
                colorScheme='blue'
                borderRadius='50%'
                h={8}
                w={8}
                minW='unset'
                onClick={() => setShowNotifications(true)}
              >
                +{notifs.length - 1}
              </Button>
            )}
            <Icon
              as={AiOutlineClose}
              onClick={() => handleUserAccept()}
              color='white'
              cursor='pointer'
              fontSize='xl'
            />
          </Flex>
        </>
      )}
    </>
  );
};
